import React, { useState } from 'react';
import Input from 'b2b-ui-components-lib/lib/components/input';
import refer from '../images/refer.svg';
import { scrollToTop, googleOrderPixel, facebookSmbLead, setInSessionStorage, removeFromSessionStorage } from '../../../common/utils/app.utils';
import { MODULE_ID, AUTHORIZATION_HEADER } from '../../../home/common/constants/constants';
import { createLead, createSiebelLead, submitExpert } from '../../../common/helper/api.helper';
import { faOnDedicatedReferBusinessSubmit } from '../../../dedicated/services/analytics.service';
import { trackMOEEvent } from '../../../common/services/moengage.service';
import { MOENGAGE_ANALYTICS_EVENT } from '../../../common/constants/app.constants';
import Button from 'b2b-ui-components-lib/lib/components/button';

const ReferBusiness = ({ showsubmitSuccess, setshowsubmitSuccess, isdedicatedJourney }) => {
  const initialFieldValue = { value: '', errors: [], touched: false };

  const [emailId, setemailId] = useState({ ...initialFieldValue });
  const [username, setusername] = useState({ ...initialFieldValue });
  const [companyName, setcompanyName] = useState({ ...initialFieldValue });
  const [mobilenumber, setmobilenumber] = useState({ ...initialFieldValue });
  //   const [disabled, setdisabled] = useState(false);

  const issubmitDisabled = !emailId.value || emailId.errors.length || !username.value || !companyName.value || !mobilenumber.value || !(mobilenumber.value.length == 10);

  const clearState = () => {
    setemailId({ ...initialFieldValue });
    setusername({ ...initialFieldValue });
    setcompanyName({ ...initialFieldValue });
    setmobilenumber({ ...initialFieldValue });
  };

  const onsubmit = () => {
    let payload = {
      email: emailId.value,
      companyName: companyName.value,
      customerName: username.value,
      phoneNumber: mobilenumber.value,
      leadSource: 'REFER_A_BUSINESS'
    };
    trackMOEEvent(MOENGAGE_ANALYTICS_EVENT.THANK_YOU_PAGE_REFER_A_BUSINESS, { ...payload });
    faOnDedicatedReferBusinessSubmit(payload);
    googleOrderPixel();
    facebookSmbLead('Refer');
    submitExpert(payload, isdedicatedJourney)
      .then((res) => {
        if (res.data.success) {
          let auth_token = res && res.headers && res.headers.authorization_token;
          if (auth_token) {
            setInSessionStorage(MODULE_ID, AUTHORIZATION_HEADER, auth_token);
          }
          createSiebelLead(isdedicatedJourney).then((res) => {
            if (res && res.data && res.data.success) {
              setshowsubmitSuccess(true);
              scrollToTop();
              clearState();
              removeFromSessionStorage(MODULE_ID, AUTHORIZATION_HEADER);
              setTimeout(() => {
                setshowsubmitSuccess(false);
              }, 5000);
            }
          });
          // .catch(err => console.error(err));
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const validateEmail = (email) => {
    const errors = [];
    let re = /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[\w-]+(\.[\w-]+)*(\.[\w-]{2,})$/;
    if (!re.test(email)) {
      errors.push('Enter valid Email');
    }
    return errors;
  };

  const validateNumber = (num) => {
    const errors = [];

    if (num.length < 10) {
      errors.push('Enter valid Number');
    }
    return errors;
  };

  const emailidChangeHandler = (value) => {
    setemailId({
      ...emailId,
      value,
      errors: validateEmail(value)
    });
  };

  const userNameChangeHandler = (value) => {
    let re = /^[A-Z. ]+$/i;
    if (value === '' || re.test(value)) {
      setusername({
        ...username,
        value
      });
    }
  };
  const companyChangeHandler = (value) => {
    setcompanyName({
      ...companyName,
      value
    });
  };
  const mobileChangeHandler = (value) => {
    let re = /^([0-9]*){10,}$/;

    if (re.test(value)) {
      setmobilenumber({
        ...mobilenumber,
        value,
        errors: validateNumber(value)
      });
    }
  };
  return (
    <div className="card-section">
      <h4>Refer a business</h4>
      <div className="accordion-card">
        <div className="accordion-content">
          <div className="row">
            <div className="flg-lg-7 flg-md-12">
              <div className="row">
                <div className="flg-lg-6 flg-md-6 flg-sm-12">
                  <div className="field-control">
                    <Input type="text" label="Add Full Name" value={username.value} errors={[]} required touched={false} onChange={(value) => userNameChangeHandler(value)} />
                  </div>
                </div>
                <div className="flg-lg-6 flg-md-6 flg-sm-12">
                  <div className="field-control">
                    <Input type="text" label="Add Company Name" value={companyName.value} errors={[]} required onChange={(value) => companyChangeHandler(value)} touched={false} />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="flg-lg-6 flg-md-6 flg-sm-12">
                  <div className="field-control">
                    <Input
                      type="text"
                      label="Add Mobile Number"
                      value={mobilenumber.value}
                      errors={mobilenumber.errors}
                      touched={mobilenumber.touched}
                      onChange={(value) => mobileChangeHandler(value)}
                      maxLength="10"
                      onBlur={() =>
                        setmobilenumber({
                          ...mobilenumber,
                          touched: true,
                          errors: validateNumber(mobilenumber.value)
                        })
                      }
                      required
                    />
                  </div>
                </div>
                <div className="flg-lg-6 flg-md-6 flg-sm-12">
                  <div className="field-control">
                    <Input
                      type="text"
                      label="Coordinator Email ID"
                      value={emailId.value}
                      onChange={(value) => emailidChangeHandler(value)}
                      required
                      errors={emailId.errors}
                      touched={emailId.touched}
                      onBlur={() =>
                        setemailId({
                          ...emailId,
                          touched: true,
                          errors: validateEmail(emailId.value)
                        })
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="next-button">
                <Button disabled={issubmitDisabled} onClick={onsubmit} className="activebtn">
                  Submit
                </Button>
              </div>
            </div>
            <div className="flg-lg-5 flg-md-12 infograph">
              <figure className="graphic">
                <img src={refer} alt="Graphic" />
              </figure>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferBusiness;
